import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { apiService } from '../../services/api_url';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import {BackIcon} from '../../assets/images/BackIcon';
import './PaymentSuccessPage.scss';

const PaymentSuccessPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
    const [countdown, setCountdown] = useState(5);
    const [paymentInfo, setPaymentInfo] = useState<any>(null);
    const [checking, setChecking] = useState(false);

    // Получаем payment_id из state (приоритет) или из URL (для совместимости)
    const statePaymentId = (location.state as any)?.payment_id;
    const urlPaymentId = searchParams.get('payment_id');

    const paymentId = statePaymentId || urlPaymentId;
    const heliketUuid = searchParams.get('uuid');
    const statusParam = searchParams.get('status');

    const checkPaymentStatus = async () => {
        // Если Heliket вернул status=success или paid
        if (statusParam === 'success' || statusParam === 'paid') {
            setStatus('success');

            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        navigate('/devices');
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }

        if (!paymentId && heliketUuid) {
            try {
                setStatus('success');

                const timer = setInterval(() => {
                    setCountdown((prev) => {
                        if (prev <= 1) {
                            clearInterval(timer);
                            navigate('/devices');
                        }
                        return prev - 1;
                    });
                }, 1000);

                return () => clearInterval(timer);
            } catch (error) {
                setStatus('error');
            }
            return;
        }

        if (!paymentId) {
            setStatus('error');
            return;
        }

        try {
            setChecking(true);

            const paymentStatus = await apiService.getPaymentStatus(paymentId);
            setPaymentInfo(paymentStatus);

            if (paymentStatus?.status === 'success') {
                setStatus('success');

                const timer = setInterval(() => {
                    setCountdown((prev) => {
                        if (prev <= 1) {
                            clearInterval(timer);
                            navigate('/devices');
                        }
                        return prev - 1;
                    });
                }, 1000);

                return () => clearInterval(timer);
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        } finally {
            setChecking(false);
        }
    };

    useEffect(() => {
        checkPaymentStatus();
    }, [paymentId, heliketUuid, statusParam, navigate]);

    const handleCheckAgain = () => {
        setStatus('processing');
        checkPaymentStatus();
    };

    const handleGoToDevices = () => {
        navigate('/devices');
    };

    const handleGoToMain = () => {
        navigate('/');
    };

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="payment-success-page">
                {status === 'processing' && (
                    <div className="success-container">
                        <div className="loader-spinner"></div>
                        <h1>Обработка платежа...</h1>
                        <p>Пожалуйста, подождите</p>
                        {heliketUuid && (
                            <p className="payment-id">Платеж: {heliketUuid.substring(0, 8)}...</p>
                        )}
                    </div>
                )}

                {status === 'success' && (
                    <div className="success-container">
                        <div className="success-icon">✓</div>
                        <h1>Оплата прошла успешно!</h1>
                        <p>Ваши устройства активированы</p>
                        {paymentInfo && (
                            <div className="payment-details">
                                <p>Сумма: {paymentInfo.amount}₽</p>
                                <p>ID: {paymentInfo.id.substring(0, 8)}...</p>
                            </div>
                        )}
                        <p className="redirect-info">Перенаправление через {countdown} сек</p>
                        <button
                            className="continue-button"
                            onClick={handleGoToDevices}
                        >
                            Перейти к устройствам
                        </button>
                    </div>
                )}

                {status === 'error' && (
                    <div className="success-container error">
                        <div className="error-icon">✕</div>
                        <h1>Ошибка при обработке платежа - советуем нажать на кнопку проверить еще раз</h1>
                        <p>Так бывает если вы оплачиваете через СБП, если вы оплатили, но платеж не подтверждается, то пожалуйста, свяжитесь с поддержкой</p>
                        {paymentId && (
                            <p className="payment-id">ID платежа: {paymentId}</p>
                        )}
                        <button
                            className="check-again-button"
                            onClick={handleCheckAgain}
                            disabled={checking}
                        >
                            {checking ? 'Проверка...' : 'Проверить еще раз'}
                        </button>
                        <div className="button-group">
                            <button
                                className="continue-button secondary"
                                onClick={handleGoToMain}
                            >
                                Вернуться на главную
                            </button>
                            <button
                                className="continue-button"
                                onClick={handleGoToDevices}
                            >
                                Проверить устройства
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccessPage;